/**
 * RTK Query endpoints — Permissions (admin)
 *
 * Migrated from: src/pages/permissions/actions.js
 *
 * The admin "permissions" page lets superusers grant/revoke role/permission
 * pairs. Mirrors the legacy endpoints:
 *   GET    /su/permissions        — full grant matrix
 *   POST   /su/permissions        — grant { role, permission }
 *   DELETE /su/permissions        — revoke { role, permission }
 */

import { baseApi } from './baseApi';

const permissionAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    permissionAdminList: builder.query({
      query: () => ({ url: '/su/permissions', method: 'GET' }),
      providesTags: [{ type: 'PermissionAdmin', id: 'LIST' }],
    }),

    grantPermission: builder.mutation({
      query: (data) => ({
        url: '/su/permissions',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'PermissionAdmin', id: 'LIST' }],
    }),

    revokePermission: builder.mutation({
      query: (data) => ({
        url: '/su/permissions',
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: [{ type: 'PermissionAdmin', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  usePermissionAdminListQuery,
  useGrantPermissionMutation,
  useRevokePermissionMutation,
} = permissionAdminApi;

export default permissionAdminApi;
